module.exports = __webpack_public_path__ + "static/media/BG_Artist.bad25b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/BG_Artist.png
// module id = 190
// module chunks = 0